var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApprove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0L22.8923 6V18L12.5 24L2.1077 18V6L12.5 0Z",
    fill: "#1BA785"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5624 15.818C11.4745 15.818 11.3921 15.8038 11.3151 15.7753C11.2382 15.7468 11.1667 15.6984 11.1008 15.6301L8.26479 12.6917C8.14388 12.5664 8.08617 12.4041 8.09167 12.2048C8.09716 12.0055 8.16037 11.8432 8.28128 11.7179C8.40219 11.5927 8.55608 11.53 8.74295 11.53C8.92982 11.53 9.08371 11.5927 9.20462 11.7179L11.5624 14.1609L17.1519 8.36956C17.2728 8.24428 17.4295 8.18164 17.6218 8.18164C17.8142 8.18164 17.9708 8.24428 18.0918 8.36956C18.2127 8.49484 18.2731 8.65713 18.2731 8.85644C18.2731 9.05575 18.2127 9.21804 18.0918 9.34332L12.0241 15.6301C11.9581 15.6984 11.8867 15.7468 11.8098 15.7753C11.7328 15.8038 11.6504 15.818 11.5624 15.818Z",
    fill: "white",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprove);
export default __webpack_public_path__ + "static/media/approve.6ec9b7d1b0df2d12a8e0e497150523e2.svg";
export { ForwardRef as ReactComponent };